module.exports = __webpack_public_path__ + "static/media/insta_switch.04831ddb.svg";